module.exports = __webpack_public_path__ + "static/interiorsflower-400a840bf8b5d180a9465ca9da430e95.png";